import React from 'react';
import Select from './Select';

const AutoSuggest = (props) => <Select {...props} exactMatch={false} showFilter={false} />;

export default AutoSuggest;
